/* eslint-disable react/prop-types */
import _ from 'lodash'
import React from 'react'
import uuidv4 from 'uuid/v4'
import { createPersistedState } from '../../cache'
import {
  createSession,
  deleteSession,
  createRegistration,
  deleteAuthenticationsByProvider
} from './auth-api'
import AuthContext from './auth-context'
import { OmnitechApi, OmnitechApiV1 } from '../../api'

const useAuthState = createPersistedState('auth')
const uuid = uuidv4()

export default function AuthProvider({ children }) {
  const [auth, setAuth] = useAuthState({
    authToken: '',
    deviceUdid: uuid,
    userId: ''
  })

  function handleSetAuth(newAuth) {
    // setup API header token in here to prevent useEffect execution order issue after Login successful
    OmnitechApi.setAuthorizationHeader({
      authToken: newAuth.authToken,
      deviceUdid: auth.deviceUdid
    })
    OmnitechApiV1.setAuthorizationHeader({
      authToken: newAuth.authToken,
      deviceUdid: auth.deviceUdid
    })
    setAuth({
      ...auth,
      ..._.pick(newAuth, ['authToken', 'userId'])
    })
  }

  function setAuthToken(authToken) {
    setAuth({
      ...auth,
      authToken
    })
  }

  function setDeviceUdid(deviceUdid) {
    setAuth({
      ...auth,
      deviceUdid
    })
  }

  function setUserId(userId) {
    setAuth({
      ...auth,
      userId
    })
  }

  async function handleCreateSession(data) {
    try {
      const promise = createSession(data)
      const { session } = await promise
      return {
        session: {
          ..._.pick(session, ['authToken', 'userId'])
        }
      }
    } catch (error) {
      throw error
    }
  }

  async function handleDeleteSession() {
    return deleteSession()
  }

  async function handleCreateRegistration(data) {
    try {
      const promise = createRegistration(data)
      const { registration } = await promise
      return {
        session: {
          ..._.pick(registration, ['authToken', 'userId'])
        }
      }
    } catch (error) {
      throw error
    }
  }

  return (
    <AuthContext.Provider value={{
      auth,
      setAuth: handleSetAuth,
      setAuthToken,
      setDeviceUdid,
      setUserId,
      createSession: handleCreateSession,
      deleteSession: handleDeleteSession,
      createRegistration: handleCreateRegistration,
      deleteAuthenticationsByProvider
    }}>
      {children}
    </AuthContext.Provider>
  )
}
